import { useState, useEffect } from "react";

import {
  GroupPassage,
  Vacancy,
  VacancyGrouped,
  VacancyMinuteOption
} from "../../interfaces/passage";

const useGrouping = (
  vacancies: Array<any>,
  date?: string,
  departure_location_id?: string,
  arrival_location_id?: string
) => {
  const [vacanciesGroupDate, setVacanciesGroupDate] = useState<
    VacancyGrouped[]
  >([]);

  const [vacanciesGroupHour, setVacanciesGroupHour] = useState<
    VacancyGrouped[]
  >([]);
  const [vacanciesGroupHourMinutes, setVacanciesGroupHourMinutes] = useState<
    VacancyGrouped[]
  >([]);

  const [minutesOptions, setMinutesOptions] = useState<VacancyMinuteOption[]>(
    []
  );

  const [hoursOptions, setHoursOptions] = useState<Array<any>>([]);

  useEffect(() => {
    // Agrupamento de data
    const vacanciesGroupDate: VacancyGrouped[] = GroupPassage(vacancies);

    // Agrupamento de horas
    const vacanciesGroupHour: Array<VacancyGrouped> = GroupPassage(
      vacancies,
      (row, vacancy) => row.date === vacancy.date && vacancy.hour === row.hour,
      (vacancy: Vacancy) => ({
        date: vacancy.date,
        hour: vacancy.hour,
        items: [vacancy]
      })
    );

    // Agrupamento de minutos por horas
    const vacanciesGroupHourMinutes: Array<VacancyGrouped> = GroupPassage(
      vacancies,
      (row, vacancy) => {
        return (
          row.date === vacancy.date &&
          vacancy.hour === row.hour &&
          vacancy.minutes === row.minutes
        );
      },
      (vacancy: Vacancy) => ({
        date: vacancy.date,
        hour: vacancy.hour,
        minutes: vacancy.minutes,
        items: [vacancy]
      })
    );

    if (date) {
      setHoursOptions(
        vacanciesGroupHour
          .filter(item => item.date === date)
          .map(item => ({
            text: item.hour,
            value: item.hour
          }))
      );

      setMinutesOptions(
        vacanciesGroupHourMinutes
          .filter(item => item.date === date)
          .map(
            item =>
              ({
                text: item.minutes,
                value: item.minutes
              } as VacancyMinuteOption)
          )
          .sort(({ value }, { value: valueB }) => {
            if (value < valueB) {
              return -1;
            }
            if (value > valueB) {
              return 1;
            }
            return 0;
          })
      );
    }

    setVacanciesGroupHour(vacanciesGroupHour);
    setVacanciesGroupHourMinutes(vacanciesGroupHourMinutes);
    setVacanciesGroupDate(vacanciesGroupDate);
  }, [vacancies, date, departure_location_id, arrival_location_id]);

  return {
    vacanciesGroupHour,
    vacanciesGroupHourMinutes,
    vacanciesGroupDate,

    minutesOptions,
    hoursOptions
  };
};

export default useGrouping;
